import { FragmentMediaPlayerSkeleton } from '../FragmentMediaPlayerSkeleton';

interface VideoSkeletonProps {
  showLoader?: boolean;
  /** Export progress percent while the video asset is being generated. */
  progressPercent?: number;
}

/**
 * Video-shaped skeleton matching the fragment video player layout and aspect ratio.
 * Spinner and message are centered over the skeleton.
 */
export function VideoSkeleton(props: VideoSkeletonProps) {
  return <FragmentMediaPlayerSkeleton aspectRatio="16 / 9" {...props} />;
}
